export default {
  PARAGRAPH: 'p'
};
